// External library
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

// Component
export default class Kanga {
    constructor () {
        this.hero = document.querySelector('.kanga-hero')
        this.kangaFixed = document.querySelector('.kanga-footer')
        this.footer = document.querySelector('#site-footer')
        this.hasElements = this.footer
            && this.hero
            && this.kangaFixed

        // If there aren't the elements we need OR isn't a small device
        if (!this.hasElements || window.innerWidth > 768)
            return

        this.start()
    }

    start () {
        ScrollTrigger.create({
            trigger: this.hero,
            start: 'bottom top', // The hero leaves the viewport
            endTrigger: this.footer,
            end: 'top bottom', // The footer enters the viewport
            toggleClass: {
                targets: this.kangaFixed,
                className: 'kanga-footer-show'
            }
        })
    }
}
